/**
 * Calculates the ETA range for delivery
 * @param eta - The base ETA in days
 * @returns String representation of the ETA range (e.g., "5-6")
 */
export const getEtaRange = (eta: number): string => {
  return `${eta}-${eta + 1}`;
};
